var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import InlineSpacer from './subcomponents';
const Inline = (_a) => {
    var { debug, size, respondToBreakpoints, hideOnBreakpointUp, hideOnBreakpointDown, hideOnlyOnBreakpoints } = _a, props = __rest(_a, ["debug", "size", "respondToBreakpoints", "hideOnBreakpointUp", "hideOnBreakpointDown", "hideOnlyOnBreakpoints"]);
    const hideProps = {};
    if (hideOnBreakpointUp) {
        hideProps.hideOnBreakpointUp = hideOnBreakpointUp;
    }
    if (hideOnBreakpointDown) {
        hideProps.hideOnBreakpointDown = hideOnBreakpointDown;
    }
    if (hideOnlyOnBreakpoints) {
        hideProps.hideOnlyOnBreakpoints = hideOnlyOnBreakpoints;
    }
    return (_jsx(InlineSpacer, Object.assign({ size: size, respondToBreakpoints: respondToBreakpoints, debug: debug }, hideProps, props)));
};
export default Inline;
//# sourceMappingURL=Inline.js.map